
  import { Vue, Component } from 'vue-property-decorator';
  import { AddressCardModel, Address } from '@/models';
  import { data } from './address-card.data'
  
  @Component
  export default class AddressCardTests extends Vue {
    model!: AddressCardModel;
    address!: Address;

    created() {
      this.address = data.address;
      this.model = data.model;
    }

    mounted() {
    }
  }
